import { useRef } from "react";
import { useTranslation } from "react-i18next";
import INTOUCH_API from "../services/Api";
import useModalActions from "./useModalActions";
import { MODAL_TYPES } from "../utils/emitter";

const CODE_FRESH_MS = 10 * 60 * 1000; // бэк держит код 15 минут

// 23.10: шаг подтверждения почты перед созданием аккаунта (RegisterPage и
// RegisterAfterDemoGamePage). confirmEmail(email, register) шлёт код на почту и
// открывает EmailCodeModal; register(code) создаёт аккаунт и возвращает
// Promise<текст ошибки | null>. Сам confirmEmail возвращает ошибку отправки кода
// или null, если окно открыто.
export default function useEmailCodeConfirm() {
  const { t } = useTranslation();
  const { openModal, closeModal } = useModalActions();
  // если окно закрыли и снова нажали «Далее» с той же почтой, второй код не шлём:
  // бэк не даёт запросить новый раньше чем через минуту
  const lastSent = useRef({ email: "", at: 0 });

  const requestCode = (email) =>
    new Promise((resolve) => {
      INTOUCH_API.requestManager(
        "registerCode",
        { email },
        () => {
          lastSent.current = { email, at: Date.now() };
          resolve(null);
        },
        (error) =>
          resolve(error?.response?.data?.message || t("email_code.send_error"))
      );
    });

  const confirmEmail = async (email, register) => {
    const isFresh =
      lastSent.current.email === email &&
      Date.now() - lastSent.current.at < CODE_FRESH_MS;
    if (!isFresh) {
      const err = await requestCode(email);
      if (err) return err;
    }
    openModal(MODAL_TYPES.EMAIL_CODE, {
      email,
      onConfirm: async (code) => {
        const err = await register(code);
        if (!err) closeModal(MODAL_TYPES.EMAIL_CODE);
        return err;
      },
      onResend: () => requestCode(email),
    });
    return null;
  };

  return { confirmEmail };
}
